module.exports = __webpack_public_path__ + "img/电子证书.d6b8a08f.png";